<template>
  <div class="con bread-crumb-container">
    <span>您现在的位置：</span>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="item in list"  :to="{path:item.path}">{{item.name}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props:{
    list:{
      type:Array,
      default:()=>
        [ ]
    }
  },
  methods:{
    pre(){
       this.$router.go(-1);
    }
  },
  watch:{
    $route(t,f){

    }
  }

}
</script>

<style lang="scss" scoped>
  .bread-crumb-container{
    color: #808080;
    font-size: 13px;
    margin: 0 auto;
    padding: 18px 0;
    display: flex;
    /deep/ .el-breadcrumb__inner{
      font-size: 13px !important;
      color: #808080 !important;
    } 
  }
  /deep/ .el-breadcrumb__inner a,  /deep/ .el-breadcrumb__inner.is-link{
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/components/plugins/bread-crumb.vue